<div [formGroup]="form">
    <div class="row">
        <ng-container *ngIf="form.value.identifier || type == 'crmsku'">
            <div class="form-group" [ngClass]="(form.value.identifier || type == 'crmsku')?'col-lg':'col-lg-4'">
                <apc-form-input [class]="!form.value.identifier && type == 'crmsku' ? 'form-control' : 'form-control autogenerated'" [disabled]="!(!form.value.identifier && type == 'crmsku')"
                    formControlName="code" [type]="'text'" [isRequired]="type == 'crmsku'">
                    <label label>{{'administration.sectionsManagement.profile.code' | translate}}</label>
                </apc-form-input>
            </div>
        </ng-container>
        <div class="form-group" [ngClass]="(form.value.identifier)?'col-lg':'col-lg-6'">
            <apc-form-input [class]="'form-control'" formControlName="name" [type]="'text'" [isRequired]="this.form.get('name').validator({})?.required">
                <label label>{{'administration.sectionsManagement.profile.value' | translate}}</label>
            </apc-form-input>
        </div>
        <div *ngIf="showManager" class="form-group col-lg">
            <apc-form-select formControlName="managerIdentifier" [items]="managers"
                optionName="fullName" [renderValue]="findManagerRenderValue()" [appendTo]="'apc-action-card'" [isRequired]="false">
                <label label>{{'administration.sectionsManagement.profile.manager' | translate}}</label>
            </apc-form-select>
        </div>
        <div class="col-lg" *ngIf="this.subsection == 'kpi' && this.type == 'type'">       
            <apc-form-input [class]="'form-control'" formControlName="groupType" [type]="'number'">
                <label label>{{'administration.sectionsManagement.operations.groupType' | translate}}</label>
            </apc-form-input>
        </div>
    </div>
</div>